import axios from 'axios';
import { API, authHeaders } from './client';

export const getSettings = (token) =>
  axios.get(`${API}/settings`, authHeaders(token)).then(r => r.data);

export const updateSettings = (token, data) =>
  axios.put(`${API}/settings`, data, authHeaders(token)).then(r => r.data);

export const changePassword = (token, data) =>
  axios.post(`${API}/auth/change-password`, data, authHeaders(token)).then(r => r.data);

export const changeEmail = (token, data) =>
  axios.post(`${API}/auth/change-email`, data, authHeaders(token)).then(r => r.data);

export const getAdmins = (token) =>
  axios.get(`${API}/auth/admins`, authHeaders(token)).then(r => r.data);

export const createAdmin = (token, data) =>
  axios.post(`${API}/auth/create-admin`, data, authHeaders(token)).then(r => r.data);

export const deleteAdmin = (token, adminId) =>
  axios.delete(`${API}/auth/admins/${adminId}`, authHeaders(token)).then(r => r.data);
